import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import determinarPaginaAtual from '../../actions/rota/determinarPaginaAtualRotas'
import BotoesPaginacao from '../comum/BotoesPaginacao'

export class BotoesPaginacaoRotas extends Component {
  render () {
    return <BotoesPaginacao
      numeroElementos={this.props.total}
      paginaAtual={this.props.paginaAtual}
      registrosPorPagina={this.props.registrosPorPagina}
      determinarPaginaAtual={this.props.determinarPaginaAtual}/>
  }
}

export function mapStateToProps (state) {
  return {
    paginaAtual: state.paginaAtualRota,
    total: state.rotas.total,
    registrosPorPagina: state.registrosPorPaginaRota
  }
}

export function mapDispatchToProps (dispatch) {
  return bindActionCreators({ determinarPaginaAtual }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(BotoesPaginacaoRotas)
